module.exports = __webpack_public_path__ + "static/media/location.02f9aeba.svg";